import * as React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface PauseRunDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (opts: { observation?: string }) => void | Promise<void>;
  pending?: boolean;
  inputId?: string;
}

export function PauseRunDialog({
  open,
  onOpenChange,
  onConfirm,
  pending = false,
  inputId = "pause-obs",
}: PauseRunDialogProps): React.ReactElement | null {
  const [observation, setObservation] = React.useState("");

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- reset observation quando dialog reabre — sync legitimo
    if (!open) setObservation("");
  }, [open]);

  if (!open) return null;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- backdrop overlay; click outside fecha
    <div
      className="fixed inset-0 z-[60] flex animate-fade-in items-center justify-center bg-background/80 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Pausar produção"
      onClick={(e) => {
        if (e.target === e.currentTarget) onOpenChange(false);
      }}
    >
      <Card className="w-full max-w-md animate-scale-in">
        <CardContent className="space-y-3 pt-6">
          <div>
            <h2 className="text-base font-semibold">Pausar produção</h2>
            <p className="text-xs text-muted-foreground">
              A pausa congela o cronômetro de produção. Adicionar uma observação ajuda no histórico
              — é opcional.
            </p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor={inputId}>Observação (opcional)</Label>
            <Input
              id={inputId}
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              placeholder="Ex: Aguardando troca de bobina"
              maxLength={1000}
              // eslint-disable-next-line jsx-a11y/no-autofocus -- primary textarea de observacao eh foco esperado por UX
              autoFocus
            />
          </div>
          <div className="flex justify-between gap-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => void onConfirm({})} disabled={pending}>
                Pausar agora
              </Button>
              <Button
                onClick={() => void onConfirm({ observation: observation.trim() || undefined })}
                disabled={pending}
              >
                {pending ? "Pausando…" : "Pausar com observação"}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
